/**
 * タイピングエフェクト
 * data-typing-delete : (1 => true / 0 => false)1つずつ表示後、後ろから削除のエフェクトを加える
 * data-typing-interval : 表示間隔(ms)
 * data-typing-delay : タイピングエフェクト開始までの遅延時間(ms)
 * data-typing-delete-delay : data-typing-deleteが有効（1）の場合、デリートエフェクト開始までの遅延時間(ms)
 * data-typing-delete-interval : data-typing-deleteが有効（1）の場合、デリートエフェクトの削除間隔(ms)
 */

document.addEventListener("DOMContentLoaded", function (event) {
  if (document.querySelector(".top_view")) {
    if (window.innerWidth > 768) {
      // PC表示
      addClassAcync("#soramame_02", "show_soramame", 500, 300)
        .then(function () {
          removeClassAcync("#soramame_02", "show_soramame", 500, 300);
          return addClassAcync("#soramame_03", "show_soramame", 500, 300);
        })
        .then(function () {
          removeClassAcync("#soramame_03", "show_soramame", 500, 300);
          return addClassAcync("#soramame_04", "show_soramame", 500, 300);
        })
        .then(function () {
          return removeClassAcync("#soramame_04", "show_soramame", 500, 300);
        })
        .then(function () {
          return typing("#copy_04");
        })
        .then(function () {
          return typing("#copy_05");
        })
        .then(function () {
          return removeClassAcync("#scroll_down", "opacity_0", 300, 500);
        });
    } else {
      // SP表示
      addClassAcync("#soramame_02", "show_soramame", 500, 300)
        .then(function () {
          removeClassAcync("#soramame_02", "show_soramame", 500, 300);
          return addClassAcync("#soramame_03", "show_soramame", 500, 300);
        })
        .then(function () {
          removeClassAcync("#soramame_03", "show_soramame", 500, 300);
          return addClassAcync("#soramame_04", "show_soramame", 500, 300);
        })
        // .then(function() {return removeClassAcync('#soramame_04', 'show_soramame', 500, 300);})
        .then(function () {
          return typing("#copy_04");
        })
        .then(function () {
          return typing("#copy_05");
        })
        .then(function () {
          return removeClassAcync("#scroll_down", "opacity_0", 300, 500);
        });
    }
  }
});

const INIT_INTERVAL = 50;

/**
 * タイピング実行関数
 * @param {String} selector
 * @returns Deferred
 */
function typing(selector) {
  console.log(selector);
  const elm = document.querySelector(selector);
  return exe(
    elm,
    getCharArray(elm.innerHTML),
    elm.dataset.typingDelete === "1" ? true : false,
    elm.dataset.typingInterval && !isNaN(Number(elm.dataset.typingInterval)) ? Number(elm.dataset.typingInterval) : INIT_INTERVAL,
    elm.dataset.typingDelay && !isNaN(Number(elm.dataset.typingDelay)) ? Number(elm.dataset.typingDelay) : 0,
    elm.dataset.typingDeleteDelay && !isNaN(Number(elm.dataset.typingDeleteDelay)) ? Number(elm.dataset.typingDeleteDelay) : 0,
    elm.dataset.typingDeleteInterval && !isNaN(Number(elm.dataset.typingDeleteInterval)) ? Number(elm.dataset.typingDeleteInterval) : INIT_INTERVAL
  );
}

/**
 * タイピングエフェクト
 * @param {jQueryオブジェクト} $elm
 * @param {String[]} charArray
 * @param {boolean} isDelete
 * @returns Deferred
 */
async function exe(elm, charArray, isDelete, interval, delay, deleteDelay, deleteInterval) {
  // var def = new $.Deferred;
  elm.innerHTML = "";
  let index = 1;
  let numChar = 0;
  if (isDelete) {
    for (let i = 0; i < charArray.length; i++) {
      for (let j = 0; j < charArray[i].length; j++) {
        numChar++;
      }
    }
  }

  return await (function () {
    return new Promise((resolve) => {
      setTimeout(function () {
        elm.classList.add("typing");
        for (let i = 0; i < charArray.length; i++) {
          for (let j = 0; j < charArray[i].length; j++) {
            if (isDelete) {
              window.setTimeout(
                function (char) {
                  elm.innerHTML = elm.innerHTML.slice(0, -1);
                  // $elm.html($elm.html().slice(0, -1));
                },
                interval * numChar + deleteInterval * index + deleteDelay,
                charArray[i][j]
              );
            }
            window.setTimeout(
              function (char) {
                elm.innerHTML += char;
              },
              interval * index,
              charArray[i][j]
            );
            index += 1;
          }
          if (i != charArray.length - 1) {
            window.setTimeout(function () {
              elm.innerHTML += "<br>";
              // $elm.html($elm.html() + '<br>');
            }, interval * index);
          }
        }
        const resTime = isDelete ? (interval + deleteInterval) * numChar + interval + deleteDelay : interval * index;
        window.setTimeout(function () {
          if (isDelete) {
            elm.classList.remove("typing");
          }
          resolve();
        }, resTime);
      }, delay);
    });
  })();

  // return def.promise();
}

/**
 * <br>を含む文字列を、<br>を除いて1文字ずつの配列にする
 * @param {String} htmlCode
 * @returns String[]
 */
function getCharArray(htmlCode) {
  const arrayPc = htmlCode.split("<br>");
  let arraySp = [];
  for (let i = 0; i < arrayPc.length; i++) {
    arraySp = arraySp.concat(arrayPc[i].split('<br class="hide_pc">'));
  }
  if (jQuery(window).width() < 769) {
    return createCharArray(arraySp);
  } else {
    return createCharArray(arrayPc);
  }
}

/**
 * 文字列配列の各文字列を1文字ずとの配列に変換
 * @param {string[]} array
 * @returns string[]
 */
function createCharArray(array) {
  const arr = [];
  for (let i = 0; i < array.length; i++) {
    arr.push(array[i].replace(/<br class="hide_pc">/g, "").split(""));
  }
  return arr;
}

/**
 * クラス追加（エフェクトがあればdelay, duration時間の分だけ遅延させる）
 * @param {String} selector
 * @param {String} className
 * @param {Number} duration
 * @param {Number} delay
 * @returns
 */
async function addClassAcync(selector, className, duration, delay) {
  setTimeout(function () {
    document.querySelector(selector).classList.add(className);
  }, delay);

  return await exeResolve(delay + duration);
}

/**
 * クラス除去（エフェクトがあればdelay, duration時間の分だけ遅延させる）
 * @param {String} selector
 * @param {String} className
 * @param {Number} duration
 * @param {Number} delay
 * @returns
 */
async function removeClassAcync(selector, className, duration, delay) {
  setTimeout(function () {
    document.querySelector(selector).classList.remove(className);
  }, delay);

  return await exeResolve(delay + duration);
}

/**
 * 指定時間経過後にresolveする
 * @param {Number} waitTime
 * @returns
 */
function exeResolve(waitTime) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, waitTime);
  });
}
